import React, { useContext } from 'react';
import styled from 'styled-components';
import Avatar from 'src/components/Avatar';
import { FileDownloadList } from '../FileDownload/FileDownloadList';
import { DocumentDetails } from 'src/state/slice/models/CommonTypes';
import Spacer from '../Layout/Spacer';
import { CorrespondenceType } from 'src/state/slice/models/CorrespondenceTypes';
import { AuthContext } from 'src/state/providers/AuthProvider';
import {
  AMAZON_USERID_REGEXP,
  UI_CLIENTS,
} from 'src/constants/GlobalConstants';
import { PostBadge } from './PostBadge';
export interface IComment {
  id: string;
  postedBy: string;
  createdByUserId: string;
  time: string;
  content: string;
  documentList: Array<DocumentDetails> | undefined;
  correspondenceType: CorrespondenceType;
}

export const CommentContainer = styled.div`
  display: flex;
  gap: 10px;
  background: ${({ theme }) => theme.colors.White};
  padding: 1em;
  margin-bottom: 0.75em;
`;

export const AvatarSection = styled.div`
  flex: none;
`;

export const CommentSection = styled.section`
  flex: 1;
`;
export const PostBadgeSection = styled.div`
  flex: none;
`;
export const Name = styled.div``;
export const Time = styled.div`
  color: ${({ theme }) => theme.colors.Tarpon};
  font-size: ${({ theme }) => theme.fontSize.s};
`;

export const CommentText = styled.div`
  white-space: pre-wrap;
  margin-top: 0.75em;
  word-break: break-all;
`;

const CommentLayout = styled.div``;

const Comment: React.FC<IComment> = ({
  id,
  content,
  postedBy,
  time,
  documentList,
  correspondenceType,
  createdByUserId,
}) => {
  const { clientId } = useContext(AuthContext);
  /**
   * Comment field is allowed to set html content using dangerouslySetInnerHTML.
   * Because the data source for the content will be an email body from the RCT tool in html format.
   * This HTML content will be generated programmatically by the text editor in the Communication page of RCT.
   * The logic for sanitizing the content will be taken during the email parsing on backend.
   */
  return (
    <CommentLayout key={id}>
      <CommentContainer>
        <AvatarSection>
          <Avatar name={postedBy}></Avatar>
        </AvatarSection>
        <CommentSection>
          <Name>{postedBy}</Name>
          <Time>{time}</Time>
          <CommentText>
            {AMAZON_USERID_REGEXP.test(createdByUserId) ? (
              <div data-testid="SecureCommentContainer">{content}</div>
            ) : (
              <div
                data-testid="UnsecureCommentContainer"
                dangerouslySetInnerHTML={{ __html: content }}
              ></div>
            )}
          </CommentText>
          <Spacer height="1.5rem" />
          <FileDownloadList attachments={documentList} />
        </CommentSection>
        {clientId == UI_CLIENTS.VICI && (
          <PostBadgeSection>
            <PostBadge correspondenceType={correspondenceType}></PostBadge>
          </PostBadgeSection>
        )}
      </CommentContainer>
    </CommentLayout>
  );
};

export default Comment;
